export const DOT_SEPARATION = 30;
export const DOT_RADIUS = 1;
export const MIN_PADDING = 30;
export const DOT_COLOUR = '#212C42';
